export const RESET_METRICS = "RESET_METRICS";

export const METRICS_ERROR = "METRICS_ERROR";

export const GET_METRICS = "GET_METRICS";

export const SET_METRICS = "SET_METRICS";

export const UPDATE_METRIC = "UPDATE_METRIC";
